import React, { useEffect } from 'react'
import {
  EventContainerStyled,
  EventCountdownStyled,
  EventDetailsContainerStyled,
  LinkStyled,
  RaceCourseNameStyled,
  RaceNumberContainerStyled,
  RaceNumberStyled,
} from '@core/Areas/VenueMode/Components/Racing/RacingEvent.styles'
import {
  RacingEventType,
  RacingPropositionType,
} from '@core/Areas/VenueMode/Components/Racing/Data/types'
import { RacingPropositions } from '@core/Areas/VenueMode/Components/Racing/RacingPropositions'
import { EventIcon } from '@core/Areas/VenueMode/Components/Racing/EventIcon'
import { CountdownBadge } from '@mobi/component-library/Feedback/CountdownBadge'
import { buildToteRaceUri } from '@core/Areas/Racing/helpers'

export interface VenueModeRacingMarketProps {
  event: RacingEventType
  selectedItem: RacingPropositionType | null
  onSelectedItemChanged: (proposition: RacingPropositionType, event: RacingEventType) => void
}

function createMatchedRaceUrl(event: RacingEventType): string {
  if (!event.fixtureId || !event.number) return ''

  return buildToteRaceUri({
    meetingId: event.fixtureId,
    raceNumber: event.number,
    meetingDate: event.fixtureDate,
  })
}

export const RacingEvent: React.FC<VenueModeRacingMarketProps> = ({
  event,
  selectedItem,
  onSelectedItemChanged,
}) => {
  useEffect(() => setMatchedRaceUrl(createMatchedRaceUrl(event)), [event])

  const [matchedRaceUrl, setMatchedRaceUrl] = React.useState<string>(createMatchedRaceUrl(event))

  return (
    <EventContainerStyled>
      <EventDetailsContainerStyled>
        <LinkStyled to={matchedRaceUrl}>
          <EventIcon />
          {/*if race number isn't present, then use the fallback detail which should hopefully contain the required info (refer api)*/}
          {event.number && (
            <>
              <RaceNumberContainerStyled>
                <RaceNumberStyled>R{event.number}</RaceNumberStyled>
              </RaceNumberContainerStyled>
              <RaceCourseNameStyled>{event.raceCourse}</RaceCourseNameStyled>
            </>
          )}
          {!event.number && <RaceCourseNameStyled>{event.fallbackDetail}</RaceCourseNameStyled>}
        </LinkStyled>

        <EventCountdownStyled>
          <CountdownBadge badgeSize='S' advertisedStartTime={new Date(event.startTime)} />
        </EventCountdownStyled>
      </EventDetailsContainerStyled>

      <RacingPropositions
        propositions={event.market.propositions}
        market={event.market}
        selectedItem={selectedItem}
        onSelectedItemChanged={proposition => onSelectedItemChanged(proposition, event)}
      />
    </EventContainerStyled>
  )
}
